
import { defineComponent, reactive, ref, onMounted } from 'vue';
//import ProgressStep from '@/bases/ProgressStep.vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

declare var gapi: any;
declare var window: any;
declare var confSlides: any;

let resultURL = 'https://docs.google.com/presentation/d/';

export default defineComponent({
  setup() {
    const router = useRouter();
    const store = useStore();

    onMounted(() => {
      if (
        store.state.token.token === null ||
        store.state.token.untill === undefined ||
        store.state.token.untill === null ||
        Date.now() > store.state.token.untill
      ) {
        router.push('/login');
      }
    });

    //const client = store.state.client;
    //client.requestAccessToken({ prompt: 'consent' });

    const status = ref<'nothing' | 'running' | 'success' | 'failure'>('nothing');
    const progressState = reactive({
      running: false,
      msg: '',
      max: 0,
      now: 0,
    });

    //const CLIENT_ID = '513774583744-852phovi1k22e5ccl5mmjqoj3hns3u1r.apps.googleusercontent.com';
    const API_KEY = 'AIzaSyBKdHoFnvjr8OGJniF9UQblKO1hDV0aQJs'; //'AIzaSyAXpncCFwR2Vm9l9vFgnEDBwpYabTV_u-E';
    const DISCOVERY_DOC = 'https://slides.googleapis.com/$discovery/rest?version=v1';

    let gapiInited = false;
    window.onGapiLoaded = initializeGapiClient();

    async function initializeGapiClient() {
      gapi.load('client:auth2', () => {
        gapi.client
          .init({
            apiKey: API_KEY,
            discoveryDocs: [DISCOVERY_DOC],
          })
          .then(
            () => {
              gapi.client.setToken({ access_token: store.state.token.token });
              gapiInited = true;
              console.log('setToken');
            },
            (error: any) => {
              alert(error['details']);
            }
          );
      });
    }

    function CheckGapiInited() {
      if (gapiInited === false) {
        window.setTimeout(CheckGapiInited, 100);
      } else {
        aggregate();
      }
    }
    CheckGapiInited();

    const aggregate = async () => {
      progressState.running = true;
      status.value = 'running';

      try {
        const response = await gapi.client.slides.presentations.create({
          title: store.state.jamboardData.title,
          pageSize: {
            width: { magnitude: 1200, unit: 'PT' },
            height: { magnitude: 800, unit: 'PT' },
          },
        });
        console.log(response);
        // 新しいプレゼンテーションのID
        var presentationId = response.result.presentationId;
        resultURL += presentationId;
        // 最初のスライドのIDを取得
        var slideId = response.result.slides[0].objectId;
        // スライドを削除/追加するリクエスト
        var requests: any = [];
        requests.push({
          deleteObject: {
            objectId: slideId,
          },
        });

        const ptPerPx = 5.4; // 補正パラメータ
        let pageNum = 1;
        store.state.jamboardData.forEach(function (jamboardData: any) {
          requests.push({
            createSlide: {
              objectId: 'slide_' + pageNum,
            },
          });
          for (let i = 0; i < jamboardData.length; i++) {
            let notesData = jamboardData[i];
            let colorCode = rgb2Hex(Number(notesData.r), Number(notesData.g), Number(notesData.b));
            let borderColorCode, noteTypesSeq;
            console.log(colorCode);
            switch (colorCode) {
              case '#ffeb3b':
                console.log('きいろ');
                colorCode = confSlides.stickyNote2.noteTypes[4].bgColor;
                borderColorCode = confSlides.stickyNote2.noteTypes[4].borderColor;
                noteTypesSeq = 5;
                break;
              case '#aeea00':
                console.log('みどり');
                colorCode = confSlides.stickyNote2.noteTypes[3].bgColor;
                borderColorCode = confSlides.stickyNote2.noteTypes[3].borderColor;
                noteTypesSeq = 4;
                break;
              case '#80deea':
                console.log('あお');
                colorCode = confSlides.stickyNote2.noteTypes[2].bgColor;
                borderColorCode = confSlides.stickyNote2.noteTypes[2].borderColor;
                noteTypesSeq = 3;
                break;
              case '#ff80ab':
                console.log('あか');
                colorCode = confSlides.stickyNote2.noteTypes[0].bgColor;
                borderColorCode = confSlides.stickyNote2.noteTypes[0].borderColor;
                noteTypesSeq = 1;
                break;
              case '#ff9e00':
                console.log('だいだい->むらさき');
                colorCode = confSlides.stickyNote2.noteTypes[1].bgColor;
                borderColorCode = confSlides.stickyNote2.noteTypes[1].borderColor;
                noteTypesSeq = 2;
                break;
              case '#000000':
                console.log('しろ->薄い灰色');
                colorCode = confSlides.stickyNote2.noteTypes[5].bgColor;
                borderColorCode = confSlides.stickyNote2.noteTypes[5].borderColor;
                noteTypesSeq = 6;
                break;
              default:
                colorCode = '#FFFFFF';
                borderColorCode = '#FFFFFF';
                break;
            }
            var rgbColor = hex2Rgb(colorCode);
            var BorderRGBColor = hex2Rgb(borderColorCode);
            // 図形を追加するリクエスト
            requests.push({
              createShape: {
                objectId: 'shape_' + pageNum + '_' + i,
                shapeType: 'RECTANGLE',
                elementProperties: {
                  pageObjectId: 'slide_' + pageNum,
                  size: {
                    height: { magnitude: notesData.transform.scale * 100, unit: 'PT' },
                    width: { magnitude: notesData.transform.scale * 100, unit: 'PT' },
                  },
                  transform: {
                    scaleX: 1,
                    scaleY: 1,
                    translateX:
                      (Number(notesData.transform.translateX.replace('px', '')) +
                        240 -
                        notesData.transform.scale * 240) /
                      ptPerPx,
                    translateY:
                      (Number(notesData.transform.translateY.replace('px', '')) +
                        240 -
                        notesData.transform.scale * 240) /
                      ptPerPx,
                    unit: 'PT',
                  },
                },
              },
            });
            // 図形の色を変更するリクエスト
            requests.push({
              updateShapeProperties: {
                objectId: 'shape_' + pageNum + '_' + i,
                fields: 'shapeBackgroundFill.solidFill.color, outline',
                shapeProperties: {
                  shapeBackgroundFill: {
                    solidFill: {
                      color: {
                        rgbColor: {
                          red: rgbColor.r,
                          green: rgbColor.g,
                          blue: rgbColor.b,
                        },
                      },
                    },
                  },
                  outline: {
                    outlineFill: {
                      solidFill: {
                        color: {
                          rgbColor: {
                            red: BorderRGBColor.r,
                            green: BorderRGBColor.g,
                            blue: BorderRGBColor.b,
                          },
                        },
                      },
                    },
                    weight: {
                      magnitude: 2,
                      unit: 'PT',
                    },
                    dashStyle: 'SOLID',
                    propertyState: 'RENDERED',
                  },
                },
              },
            });
            // 図形に文字を挿入するリクエスト
            requests.push({
              insertText: {
                objectId: 'shape_' + pageNum + '_' + i,
                insertionIndex: 0, // テキストを挿入する位置
                text: notesData.text, // 挿入するテキスト
              },
            });
            let description = {
              noteTypesSeq: noteTypesSeq,
              shapeType: 'RECTANGLE',
              googleId: '',
              templateNoteFlg: false,
            };
            // 図形に代替テキストとタイトルを付与するリクエスト
            requests.push({
              updatePageElementAltText: {
                objectId: 'shape_' + pageNum + '_' + i,
                title: 'ZETTA_STICKYNOTE',
                description: JSON.stringify(description),
              },
            });
          }
          pageNum++;
        });

        console.log(requests);

        await gapi.client.slides.presentations.batchUpdate({
          presentationId: presentationId,
          requests: requests,
        });
      } catch (err: any) {
        console.log(err.message);
        // window.setTimeout(aggregate, 1000);
        return;
      }

      /*const presentation = response.result;
      if (!presentation || !presentation.slides || presentation.slides.length == 0) {
        console.log('No slides found.');
        return;
      }*/
      status.value = 'success';
      progressState.running = false;
    };
    const openResult = () => {
      window.location.href = resultURL;
      //window.open(resultURL, '_blank');
    };
    function rgb2Hex(r: number, g: number, b: number) {
      // 各色を16進数に変換し、必要に応じてゼロ埋めを行う
      const toHex = (color: number) => color.toString(16).padStart(2, '0');
      // RGB値をHEX形式に変換
      return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    }

    function hex2Rgb(hex: any) {
      // HEXコードからRGB値を取得
      var r = parseInt(hex.slice(1, 3), 16) / 255;
      var g = parseInt(hex.slice(3, 5), 16) / 255;
      var b = parseInt(hex.slice(5, 7), 16) / 255;
      return { r, g, b };
    }

    return {
      status,
      aggregate,
      progressState,
      openResult,
    };
  },
});
